var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"dev-component"}},[_c('production',_vm._b({tag:"component",attrs:{"dev":"","classroomId":_vm.classroomId}},'component',Object.assign({}, _vm.devData),false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }